// SEARCH PAGE

function loadMoreSearchReaults(btn,query,page) {
    console.info('Sending data');
    
    // add btn loading
    btnLoading.add(btn);

    // create request and data
    const XHR = new XMLHttpRequest();
    const formData = new FormData();
        formData.append('q',query);
        formData.append('page',page);
        
    const urlEncodedData = new URLSearchParams(formData).toString();

    // successful
    XHR.addEventListener('load', (e) => {

        // process response
        if (e.target.response){
            var results_placeholder = document.getElementById('search-results-placeholder');
            
            var response = e.target.response,
                results_button = response.getElementById('search-results-button');
            
            if (typeof(results_button) != 'undefined' && results_button != null)
            {
                var page = results_button.dataset.page * 1;
                // set next page for new button in response data
                response.getElementById('search-results-button').dataset.page = page + 1;
            }
            
            // replace button row with new results and button
            results_placeholder.outerHTML = response.getElementById('search-results').innerHTML;

            // remove btn loading
            btnLoading.rem(btn);
        }
    });
    
    // error
    XHR.addEventListener('error', (e) => {
        // remove btn loading
        btnLoading.rem(btn);
    });

    // Set up request
    XHR.open('POST', cyclone3.domain + '/search');

    // Add the required HTTP header for form data POST requests
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    // Send our data.
    XHR.responseType = "document";
    XHR.send(urlEncodedData);
};